import { Record } from 'immutable';

export type ApiConvUser = {
  name: string;
  user_no: number;
}

const ConvUserBase = Record({
  name: "",
  userNo: 0,
});

class ConvUser extends ConvUserBase {
  constructor(apiConvUser?: ApiConvUser) {
    super({
      name: apiConvUser?.name,
      userNo: apiConvUser?.user_no,
    })
  }
}

export type ApiConv = {
  id: number;
  donor: ApiConvUser;
  donee: ApiConvUser;
  hidden_by_donor: boolean;
  hidden_by_donee: boolean;
};

const ConvBase = Record({
  id: 0,
  donor: new ConvUser(),
  donee: new ConvUser(),
  hiddenByDonor: false,
  hiddenByDonee: false,
  hidden: false
});

export class Conv extends ConvBase {
  constructor(apiConv?: ApiConv, isDonee?: boolean) {
    super({
      id: apiConv?.id,
      donor: new ConvUser(apiConv?.donor),
      donee: new ConvUser(apiConv?.donee),
      hiddenByDonor: apiConv?.hidden_by_donor ?? false,
      hiddenByDonee: apiConv?.hidden_by_donee ?? false,
      hidden: isDonee ? (apiConv?.hidden_by_donee ?? false) : (apiConv?.hidden_by_donor ?? false)
    })
  }
}
